import { jsxs as d, jsx as s } from "react/jsx-runtime";
import e from "./index.es2322.js";
import { calculateDimensions as B } from "./index.es2323.js";
import o from "classnames";
import "react";
import { numberFormat as D } from "./index.es2324.js";
import { useTheme as H } from "./index.es173.js";
import { BodyText as x } from "./index.es487.js";
const A = "mini-bar-chart", V = ({
  bins: l,
  fitContainer: h,
  labelAlignment: p = "left",
  labelPrefix: u,
  labelSuffix: b,
  hideLabels: f,
  testId: r = A,
  labelFixedWidth: n
}) => {
  const v = H(), m = B(l, h), N = Math.max(...l.map((a) => a.value)), i = p === "right", $ = o(e.container, {
    [e.flipped]: i
  }), g = o(e.labels, {
    [e.flipped]: i
  }), y = o(e.label, {
    [e.flipped]: i
  }), C = o(e.bars, {
    [e.flipped]: i
  }), T = n ? { width: n } : {};
  return /* @__PURE__ */ d(
    "div",
    {
      style: { height: m.containerHeight },
      className: $,
      "data-testid": r,
      children: [
        !f && /* @__PURE__ */ s("div", { className: g, role: "list", style: T, children: l.map((a, t) => {
          const c = D({
            number: a.value,
            maximumFractionDigits: 2,
            formatThousands: !0
          });
          return /* @__PURE__ */ s(
            "div",
            {
              className: y,
              style: { height: m.barHeight },
              role: "listitem",
              children: /* @__PURE__ */ d(
                x,
                {
                  size: "small",
                  color: "secondary",
                  variant: "semi-bold",
                  testId: `${r}-label-${t}`,
                  isEllipsis: !0,
                  children: [
                    u,
                    c,
                    b
                  ]
                }
              )
            },
            `label-${t}`
          );
        }) }),
        /* @__PURE__ */ s("div", { className: e.divider }),
        /* @__PURE__ */ s("div", { className: C, "data-testid": `${r}-bars`, role: "list", children: l.map((a, t) => {
          const c = `${a.value / N * 100}%`, _ = v.activeTheme.theme.POI[a.entityColor].default;
          return /* @__PURE__ */ s(
            "div",
            {
              "data-testid": `${r}-bar-${t}`,
              style: {
                width: c,
                height: m.barHeight,
                backgroundColor: _
              },
              role: "listitem",
              "aria-label": `Bar ${t + 1}: ${a.value}`
            },
            `bar-${t}`
          );
        }) })
      ]
    }
  );
};
export {
  A as MINI_BAR_CHART_DEFAULT_TEST_ID,
  V as MiniBarChart
};
//# sourceMappingURL=index.es141.js.map
